import React from 'react';
import { reduxForm, Form } from 'redux-form';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

import { AppTextField } from 'components/form/appTextField';
import { minLength, required } from 'components/form/formValidations';
import Icon from 'components/utils/icon';
import { SearchFormProps, SearchFormDataProps, SearchFormOnSubmitProps } from './SearchForm.types';
import styles from './SearchForm.module.scss';

const validate = [required, minLength(3)];

const SearchForm = ({ onSearch, handleSubmit, pristine, submitting }: SearchFormProps) => {
  const handleOnParticipantSearch = ({ search }: SearchFormDataProps) => onSearch(search);

  return (
    <Form onSubmit={handleSubmit(handleOnParticipantSearch)} className={styles.container}>
      <div className={styles.wrapper}>
        <AppTextField
          name="search"
          placeholder="Search"
          validate={validate}
          key="search"
          hiddenLabel
          className={styles.inputContainer}
          inputClassName={styles.inputWrapper}
        />
        <button type="submit" className={styles.button} disabled={pristine || submitting}>
          <Icon icon={faSearch} />
        </button>
      </div>
    </Form>
  );
};

export const SearchFormContainer = reduxForm<SearchFormDataProps, SearchFormOnSubmitProps>({
  form: 'participantSearch',
  // @ts-ignore
})(SearchForm);
